import { useQueryParam } from './useQueryParam';

export const useNoNav = (): boolean => {
  const outputType = useQueryParam('outputType');

  return outputType === 'nonav';
};
